import React, { useState } from "react";
import { Form, Formik } from "formik";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Flex,
  Text,
  FormErrorMessage,
  Input,
  Select,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { setMarriageRefInfo } from "../redux/slices/studentRegistrationSlice";
import * as yup from "yup";

const StudentMarriageForm = ({ handleNext, handlePrevious }) => {
  const dispatch = useDispatch();
  const marriageRefInfo = useSelector(
    (state) => state?.individualRegistration?.marriageRefInfo
  );
  const registeredIndividuals = useSelector(
    (state) => state?.individualRegistration?.registerIndividual?.data
  );
  const [uploadedFileName, setUploadedFileName] = useState("");

  const initialValues = {
    maritalStatus:
      marriageRefInfo?.maritalStatus ||
      registeredIndividuals?.marriageInfo?.maritalStatus ||
      "",
    marriageCertfile: "",
  };

  const validationSchema = yup.object().shape({
    maritalStatus: yup.string().required("Marital status is required"),
    marriageCertfile: yup
      .mixed()
      .nullable()
      .when("maritalStatus", {
        is: "Married",
        then: (schema) =>
          schema
            .required("Marriage certificate is required")
            .test(
              "fileSize",
              "File too large",
              (value) => value && value.size <= 500000
            )
            .test(
              "fileType",
              "Unsupported file format, Only png, jpg, jpeg, pdf files are allowed",
              (value) =>
                value &&
                ["image/jpeg", "image/png", "application/pdf"].includes(
                  value.type
                )
            ),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

  const handleSubmit = (values) => {
    dispatch(setMarriageRefInfo(values));
    handleNext(values);
  };

  return (
    <Box>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          touched,
          values,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <Form style={{ width: "100%" }}>
            <Box px={"50px"}>
              <Text fontSize={"20px"} fontWeight={"700"}>
                Marriage Information
              </Text>
              <Text mt={3} mb={5} fontSize={"16px"}>
                If applicable, upload a Marriage Certificate (JPEG, PDF, PNG.
                Max: 500KB).
              </Text>
              <Flex flexDirection={"row"} gap={5}>
                <FormControl
                  isInvalid={errors.maritalStatus && touched.maritalStatus}
                >
                  <FormLabel>Marital Status</FormLabel>
                  <Select
                    name="maritalStatus"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    placeholder="Select Here"
                    value={values.maritalStatus}
                  >
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Divorced">Divorced</option>
                  </Select>
                  <FormErrorMessage>{errors.maritalStatus}</FormErrorMessage>
                </FormControl>

                {values.maritalStatus === "Married" && (
                  <FormControl
                    isInvalid={
                      errors.marriageCertfile && touched.marriageCertfile
                    }
                  >
                    <FormLabel>Marriage Certificate</FormLabel>
                    <Input
                      type="file"
                      name="marriageCertfile"
                      onBlur={handleBlur}
                      onChange={(event) => {
                        const file = event.currentTarget.files[0];
                        setFieldValue("marriageCertfile", file);
                        setUploadedFileName(file?.name || "");
                      }}
                      accept=".pdf, .jpg, .jpeg, .png"
                    />
                    {uploadedFileName && (
                      <Text fontSize={"14px"}>
                        Uploaded File: {uploadedFileName}
                      </Text>
                    )}
                    <FormErrorMessage>
                      {errors.marriageCertfile}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Flex>
            </Box>
            <Flex
              px={"50px"}
              flexDirection={"row"}
              gap={"50px"}
              alignItems={"center"}
              mt={"80px"}
              mb={10}
            >
              <Button
                bg={"#A6A6A6"}
                color={"#FFFFFF"}
                w={"200px"}
                onClick={handlePrevious}
              >
                Previous
              </Button>
              <Button
                bg={"#23A455CC"}
                color={"#FFFFFF"}
                w={"200px"}
                type="submit"
              >
                Next
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default StudentMarriageForm;
